var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertExists } from '@blocksuite/global/utils';
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { getEdgelessPageByElement } from '../_common/utils/query.js';
import { Bound } from '../surface-block/utils/bound.js';
export const EdgelessBookmarkWidth = {
    horizontal: 752,
    list: 752,
    vertical: 364,
    cube: 170,
};
export const EdgelessBookmarkHeight = {
    horizontal: 114,
    list: 46,
    vertical: 390,
    cube: 114,
};
let EdgelessBookmarkBlockComponent = class EdgelessBookmarkBlockComponent extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this._showCaption = false;
    }
    get model() {
        return this.block.model;
    }
    get edgeless() {
        const edgeless = getEdgelessPageByElement(this);
        assertExists(edgeless);
        return edgeless;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!!this.model.caption && this.model.caption.length > 0) {
            this._showCaption = true;
        }
        this.disposables.add(this.edgeless.slots.elementUpdated.on(({ id }) => {
            if (id === this.model.id) {
                this.requestUpdate();
            }
        }));
    }
    render() {
        const style = this.model.style;
        const width = EdgelessBookmarkWidth[style];
        const height = EdgelessBookmarkHeight[style];
        const bound = Bound.deserialize((this.edgeless.surface.pickById(this.model.id) ??
            this.model).xywh);
        const scaleX = bound.w / width;
        const scaleY = bound.h / height;
        return html `<div
      style=${styleMap({
            width: `${width}px`,
            height: `${height}px`,
            pointerEvents: 'none',
            transform: `scale(${scaleX}, ${scaleY})`,
            transformOrigin: '0 0',
        })}
    >
      <bookmark-card .bookmark=${this.block}></bookmark-card>
      <bookmark-caption
        .bookmark=${this.block}
        .display=${this._showCaption}
        @blur=${() => {
            if (!this.model.caption) {
                this._showCaption = false;
            }
        }}
      ></bookmark-caption>
      ${this.block.selected?.is('block')
            ? html `<affine-block-selection></affine-block-selection>`
            : null}
    </div>`;
    }
};
__decorate([
    property({ attribute: false })
], EdgelessBookmarkBlockComponent.prototype, "block", void 0);
__decorate([
    state()
], EdgelessBookmarkBlockComponent.prototype, "_showCaption", void 0);
EdgelessBookmarkBlockComponent = __decorate([
    customElement('affine-edgeless-bookmark')
], EdgelessBookmarkBlockComponent);
export { EdgelessBookmarkBlockComponent };
//# sourceMappingURL=edgeless-bookmark-block.js.map